import { ProductVariant } from '@/types/product-variant-type';

// Extended ProductVariant with stock information
export interface ProductVariantWithStock extends ProductVariant {
  stock?: {
    stockInHand?: number;
    closingQty?: number;
    openQty?: number;
    soldQty?: number;
    receivedQty?: number;
    adjustInQty?: number;
    adjustOutQty?: number;
  };
}

export type OrderItemRow = { variantId: string; quantity: number };

// Helper function to get stock in hand
export function getStockInHand(variant: ProductVariantWithStock): number {
  if (variant.stock?.stockInHand !== undefined) {
    return variant.stock.stockInHand;
  }
  if (variant.stock?.closingQty !== undefined) {
    return variant.stock.closingQty;
  }
  return 0;
}

// Helper function to get stock badge color classes
export function getStockBadgeColor(stockInHand: number): string {
  if (stockInHand === 0) {
    return 'bg-destructive/10 text-destructive border-destructive/20';
  }
  if (stockInHand < 10) {
    return 'bg-orange-50 text-orange-700 border-orange-200';
  }
  return 'bg-muted text-muted-foreground border-border';
}

// Format currency consistently
export function formatCurrency(amount: number): string {
  return `$${Number(amount || 0).toFixed(2)}`;
}

